import { useState } from "react";

const links = [
  { href: "#entrance", label: "最新入口" },
  { href: "#flash", label: "快讯时间线" },
  { href: "#collection", label: "专题合集" },
  { href: "#topics", label: "分类直达" },
  { href: "#guide", label: "使用指南" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-stone-200/70 bg-[#fbf7f0]/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#" className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-600 text-white">
            <i className="ri-road-map-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-bold tracking-tight text-stone-900">吃瓜线路</span>
            <span className="mt-0.5 text-[11px] font-medium text-orange-700">防走丢 · 永久地址</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap text-sm font-medium text-stone-600 transition-colors hover:text-orange-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <span className="flex items-center gap-1.5 whitespace-nowrap rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs font-medium text-emerald-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500"></span>
            </span>
            通道正常
          </span>
          <a
            href="#entrance"
            className="flex items-center gap-1 whitespace-nowrap rounded-md bg-orange-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-orange-700"
          >
            进入最新入口
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-stone-200 text-stone-700 md:hidden"
          aria-label="打开菜单"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-stone-200 bg-[#fbf7f0] px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-stone-700 hover:bg-orange-50 hover:text-orange-700"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <a
            href="#entrance"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-orange-600 px-4 py-2.5 text-sm font-semibold text-white"
          >
            进入最新入口 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      )}
    </header>
  );
}